import React, { Fragment } from 'react';
import { Colorway } from '@uds/theme-utils';
import { useStyles } from '@team-griffin/stylr';
import { isNilOrEmpty } from 'presentation/utils/generalUtils';

const logoOnDark =
  'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/9f2eeecc-b670-4bc1-a366-878f0de5122c/dark-288x72.png';
const logoOnLight =
  'https://img1.wsimg.com/cdn/Image/All/AllChannelsFoS/1/en-US/68137afe-5794-4f19-b4aa-f8d5fd8f0215/light-288x72.png';

interface OuterProps {
  url: string;
  colorway: Colorway;
}
const getLogoForColorway = (colorway: Colorway) => {
  switch (colorway) {
    case Colorway.DARK:
    case Colorway.HIGHLIGHT:
    case Colorway.PRIMARY:
    case Colorway.PRIMARY_GRADIENT:
      return logoOnDark;
    default:
      return logoOnLight;
  }
};

const useStylesheet = () =>
  useStyles({
    default: {
      root: {
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
      },
    },
  });

export const Logo = ({ colorway, url }: OuterProps) => {
  const { styles } = useStylesheet();
  const Component = isNilOrEmpty(url) ? Fragment : 'a';
  const logo = getLogoForColorway(colorway);
  return (
    <Component href={url} target="_blank">
      <img loading="lazy" src={logo} alt="Trustpilot" style={styles.root} />
    </Component>
  );
};

Logo.displayName = 'Logo';

export default Logo;
